import { createContext, useState, useEffect, useContext, React } from "react";
import Swal from "sweetalert2";
import { NemuContext } from "../utils/NemuContext";
import {
  login,
  register,
  enterpriseProfile,
  verifyToken,
  updateEnterpriseProfile,
  createAcknowledgment,
  deleteAcknowledge,
  profileAcknowledge,
  updateAcknowledge,
  updateNemu,
  createDevelopment,
  getDevelopmentByUserId,
  getDevelopmentById,
  createDraft,
  updateDevelopment,
  addAmenityToDevelopment,
  countDevelopmentsByUserId,
  userPaymentPlans,
} from "./Auth";
import { set } from "react-hook-form";

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [enterprise, setEnterprise] = useState(null);
  const [myProjects, setMyProjects] = useState(0);
  const [paymentPlans, setPaymentPlans] = useState([]);
  const [count, setCount] = useState(0); // Variable para contar los desarrollos de un usuario
  const [coverPage, setCoverPage] = useState(null);
  const [acknowledge, setAcknowledge] = useState([]);

  const signUp = async (data) => {
    try {
      const response = await register(data);
      setUser(response.data);
      setIsLoggedIn(true);
      return response.data;
    } catch (error) {
      setError(error);
    }
  };

  const newDevelopment = async (data) => {
    try {
      const response = await createDevelopment(data);
      await getUserDevelopment(user.id);
      console.log("Llamando a getUserDevelopment");
      console.log(response.data);
      return response.data;
    } catch (error) {
      setError(error);
    }
  };
  const addAmenity = async (data) => {
    try {
      //console.log('Amenity', data);
      const response = await addAmenityToDevelopment(data);
      return response;
    } catch (error) {
      setError(error);
    }
  };

  const updateDevelopmentNew = async (id, data) => {
    try {
      // console.log(data);
      const response = await updateDevelopment(id, data);
      await addAmenity({ id, amenities: data.amenities });
      // await getUserDevelopment(user.id);
      // console.log('actualidar desarrollo', response);
      return response;
    } catch (error) {
      const errorMessage = error.message.replace(/Error:|error:/gi, "").trim();
      console.log(errorMessage);
      Swal.fire({
        icon: "error",
        title: "No se pudo actualizar",
        text: errorMessage,
      });
      setError(error);
    }
  };

  const getCountDevelopments = async (id) => {
    try {
      const response = await countDevelopmentsByUserId(id);
      // console.log("Conteo", response);
      setCount(response);
      return response;
    } catch (error) {
      setError(error);
    }
  };

  const getUserPaymentPlans = async (id) => {
    try {
      const response = await userPaymentPlans(id);
      // console.log("Planes", response);
      setPaymentPlans(response);
      return response;
    } catch (error) {
      setError(error);
    }
  };

  const getUserDevelopment = async (id) => {
    // console.log(id);
    try {
      const response = await getDevelopmentByUserId(id);

      // console.log("AAA",response);
      const sortedProjects = [...response.data.message].sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
      setMyProjects(sortedProjects);
      await getCountDevelopments(id);

      return response.data;
    } catch (error) {
      setError(error);
    }
  };

  const getDevelopment = async (id) => {
    try {
      const response = await getDevelopmentById(id);
      console.log(response.data);
      return response.data;
    } catch (error) {
      setError(error);
    }
  };

  const newAcknowledgment = async (data) => {
    try {
      const response = await createAcknowledgment(data);
      console.log(response.data.data);
      setAcknowledge(prev => [...prev, response.data.data]);
      return response.data.success;
    } catch (error) {
      setError(error);
      return false;
    }
  };

  const delAcknowledge = async (id) => {
    try {
      const response = await deleteAcknowledge(id);
      if(response.data.success){
        setAcknowledge(prev => prev.filter(ack => ack.id !== id));
        return response.data.success;
      }
    } catch (error) {
      setError(error);
      return false;
    }
  };

  const updAcknowledge = async (data,id) => {
    try {
      const response = await updateAcknowledge(data,id);
      if(response.data.success){
        setAcknowledge(prev => prev.filter(ack => ack.id !== data));
        return response;
      }
    } catch (error) {
      setError(error);
      return false;
    }
  };

  const createDraftProject = async (data) => {
    try {
      const response = await createDraft(data);
      await getUserDevelopment(user.id);
      console.log(response.data);
      return response.data;
    } catch (error) {
      setError(error);
    }
  };

  const getProfileAcknowledge = async (id) => {
    try {
      const response = await profileAcknowledge(id);
      // console.log(response.data);
      return response.data;
    } catch (error) {
      setError(error);
    }
  };

  const signIn = async (data) => {
    try {
      setLoading(true);
      // Primero hacemos login
      const loginResponse = await login(data);
      const token = loginResponse.data.token;
      const user = loginResponse.data.user;

      // console.log("Login Response:", loginResponse.data.user.role);
      
      
      localStorage.setItem("token", token);

      // Verificamos el token
      const verifyResponse = await verifyToken();

      // console.log(verifyResponse.data);

      // Obtenemos el perfil de empresa
      const enterpriseResponse = await enterpriseProfile(
        loginResponse.data.user.id
      );

      // Una vez que tenemos toda la información, actualizamos el estado
      setUser(loginResponse.data);
      // console.log(enterpriseResponse.data);
      setEnterprise(enterpriseResponse.data);
      setIsLoggedIn(true);
      setError(null);
      return loginResponse.data;
    } catch (error) {
      setError(error);
      // Limpiamos el estado en caso de error
      logout();
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    setUser(null);
    setEnterprise(null);
    setIsLoggedIn(false);
    localStorage.removeItem("token");
  };

  const getProfileEnterPrise = async (id) => {
    try {
      const response = await enterpriseProfile(id);
      // console.log(response);
      
      setEnterprise(response.data);
    } catch (error) {
      setError(error);
    }
  };

  const updateProfileEnterprise = async (id, data) => {
    console.log(id);
    console.log(data);
    try {
      const response = await updateEnterpriseProfile(id, data);
      if (response.data) {
        Swal.fire({
          icon: "success",
          title: "¡Datos actualizados!",
          text: "Los datos de tu empresa han sido actualizados correctamente",
        });
        await getProfileEnterPrise(id);
      }
    } catch (error) {
      setError(error);
    }
  };

  const updateNemuProfile = async (id, data) => {
    console.log(data);
    
    try {
      const response = await updateNemu(id, data);
      await getProfileEnterPrise(id);
      return response.data;
    } catch (error) {
      setError(error);
    }
  };

  useEffect(() => {
    // Definir la función asincrónica dentro de useEffect
    const checkToken = async () => {
      const token = localStorage.getItem("token");

      // Si no hay token, se borra la sesión
      if (!token) {
        setUser(null);
        setLoading(false);
        setIsLoggedIn(false);
        setEnterprise(null);
        setError(null);
        return;
      }

      try {
        // Verificar el token usando la función asincrónica
        const response = await verifyToken(); // Si la función verifyToken requiere más datos, los puedes pasar aquí

        if (response) {
          setUser(response.data);
          setIsLoggedIn(true);
          await getUserDevelopment(response.data.id);
          await getProfileEnterPrise(response.data.id); // Asumiendo que esta función también es asincrónica
          await getUserPaymentPlans(response.data.id);
        }

        setLoading(false); // No olvidar actualizar el estado cuando termine
      } catch (err) {
        console.error("Error al verificar el token:", err);
        setError(err);
        setLoading(false); // Asegurarse de que se termine el loading en caso de error
      }
    };

    checkToken(); // Ejecutar la función asincrónica
  }, []); // Dependencias vacías, solo se ejecuta una vez al montar el componente

  return (
    <AuthContext.Provider
      value={{
        user,
        signUp,
        signIn,
        logout,
        loading,
        error,
        coverPage,
        setCoverPage,
        acknowledge,
        setAcknowledge,
        isLoggedIn,
        enterprise,
        getProfileEnterPrise,
        updateProfileEnterprise,
        newAcknowledgment,
        delAcknowledge,
        updAcknowledge,
        getProfileAcknowledge,
        updateNemuProfile,
        newDevelopment,
        getUserDevelopment,
        getDevelopment,
        getUserPaymentPlans,
        myProjects,
        setMyProjects,
        createDraftProject,
        updateDevelopmentNew,
        count,
        paymentPlans,
        setPaymentPlans,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
